import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, IUsaState } from './index';

export interface UsaStateByIdGetParams {
  id: string;
}

export const usaStateById = (payload: UsaStateByIdGetParams): Action<UsaStateByIdGetParams> => ({
  type: actions.usaStateByIdTrigger.toString(),
  payload,
});

export const usaStateByIdClear = (): Action => ({
  type: actions.usaStateByIdClear.toString(),
});

export const usaStateByIdErrorClear = (): Action => ({
  type: actions.usaStateByIdErrorReset.toString(),
});

export function* usaStateByIdRequestSaga({ payload }: Action<UsaStateByIdGetParams>) {
  yield put({
    type: actions.usaStateByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.usaStateByIdError.toString(),
      payload: {
        message: 'UsaStateById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/usa-states/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<IUsaState, IUsaState>(
    response,
    actions.usaStateByIdSuccess.toString(),
    actions.usaStateByIdError.toString(),
    false,
    (usaStateByIdData) => usaStateByIdData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.usaStateByIdTrigger.toString(),
    defaultProcessingSaga(
      usaStateByIdRequestSaga,
      {
        error: actions.usaStateByIdError.toString(),
        locationCancel: actions.usaStateByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.usaStateByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.usaStateByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.usaStateByIdErrorReset.toString(),
    });
  });
}
